import { forwardRef } from "react";

import type { HeadlineProps } from "./headline.types";
import { headlineStyles } from "./headline.styles";

export const Headline = forwardRef<HTMLHeadingElement, HeadlineProps>((props, ref) => {
  const { children, as = "h2", size, weight = "bold", className, ...rest } = props;

  const HeadingTag = as;

  const classes = headlineStyles({ size, weight, className });

  return (
    <HeadingTag ref={ref} className={classes} {...rest}>
      {children}
    </HeadingTag>
  );
});
